import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  id: "show-webhook",
  class: "d-flex flex-fill list-page"
}
const _hoisted_2 = ["id"]
const _hoisted_3 = { class: "d-flex flex-row justify-content-between" }
const _hoisted_4 = { class: "col margin-left-3" }
const _hoisted_5 = { class: "d-flex flex-row align-items-center" }
const _hoisted_6 = {
  key: 0,
  class: "loader-25 margin-left-3"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "pagination-wrapper mt-1" }
const _hoisted_9 = { class: "loader-div-40" }
const _hoisted_10 = ["src"]

import {
  defineAsyncComponent,
  onMounted,
  onUnmounted,
  ref,
  watchEffect,
} from "vue";
import {
  ElButton,
  ElCard,
  ElDropdown,
  ElDropdownItem,
  ElDropdownMenu,
  ElInput,
  ElTable,
  ElTableColumn,
  ElTag,
} from "element-plus";
import { TYPE } from "vue-toastification";
import { useRouter } from "vue-router";
import {
  getPayloadById,
  getWebhookById,
  getWebhookListing,
  isProcessed,
  startPayload,
} from "@/webhook/services/webhook_payload.service";
import {
  authInfo,
  hasPermission,
  updateMultiplePreference,
  updateSinglePreference,
} from "@/core/auth";
import { getPreferenceValue } from "@/core/preferences/preferences";
import { ASSETS_BASE_URL, DEFAULT_LOGO } from "@/core/logo";
import i18n from "@/core/i18n/i18n";
import { showAlert } from "@/core/popup";
import { connectWebsocket, getLatestLogs } from "@/flow/services/flow.service";
import { useDebouncedSearch } from "@/core/composables/useDebouncedSearch";
import { useLatestRequestGuard } from "@/core/composables/useLatestRequestGuard";
import OneTegPagination from "@/common/components/OneTegPagination.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'WebhookPayload',
  emits: ["toggle-popup", "close-popup"],
  setup(__props, { emit: __emit }) {

const router = useRouter();

const { t } = i18n.global;
const webhooksRequestGuard = useLatestRequestGuard();

const ViewPayload = defineAsyncComponent(
  () => import("@/webhook/pages/ViewPayload.vue")
);

const SimulateDialog = defineAsyncComponent(
  () => import("@/flow/components/SimulateDialog.vue")
);

const webhookList = ref([]);

const loadingWebhooks = ref(false);

const search = ref("");

const sortField = ref(
  getPreferenceValue("webhooksSortField")
    ? getPreferenceValue("webhooksSortField")
    : "createdAt"
);

const sortAscending = ref(
  getPreferenceValue("webhooksSortOrder")
    ? getPreferenceValue("webhooksSortOrder")
    : "ascending"
);

const perPageWebhooks = ref(
  getPreferenceValue("pageSize") ? getPreferenceValue("pageSize") : 10
);

const currentPageWebhooks = ref(1);

const numberOfWebhooks = ref(0);

const buttonTrigger = ref(false);

const simulateDialogVisible = ref(false);

const payloadContent = ref("");

const flowName = ref("");

const flowList = ref([]);

const selectedBuffer = ref([]);

const outputBuffer = ref([]);

const outputMap = ref<Map<any, any>>(new Map());

const selectedFlowId = ref();

let client;

const statusClient = ref();

const rowStyle = ref({
  cursor: "pointer",
  backgroundColor: "#fbfbfb",
});

const emit = __emit;
async function togglePopup(payloadId) {
  buttonTrigger.value = false;
  payloadContent.value = "";
  const payloads = await getPayloadById(payloadId);
  payloadContent.value = payloads;
  buttonTrigger.value = true;
  emit("toggle-popup");
}

function closePopup() {
  buttonTrigger.value = false;
  emit("close-popup");
}

function closeSimulateDialog() {
  simulateDialogVisible.value = false;
}

function sizeChanged(val) {
  perPageWebhooks.value = val;
  updateSinglePreference("pageSize", val);
  getWebhooks();
}

const { onSearchInput } = useDebouncedSearch(getWebhooks);

function sortChanged(sort) {
  sortField.value = sort.prop;
  sortAscending.value = sort.order;
  updateMultiplePreference({
    webhooksSortField: sort.prop,
    webhooksSortOrder: sort.order,
  });
  getWebhooks();
}

onMounted(() => {
  getWebhooks();
  if (authInfo.value) {
    connectWebsocket().then((stompClient) => {
      stompClient.debug = (f) => f;
      statusClient.value = stompClient;
      stompClient.connect({}, () => {
        stompClient.subscribe(
          `/organization/${authInfo.value.organizationId}/flow/status`,
          (val) => {
            const statusData = JSON.parse(val.body);
            const flow = flowList.value.find(
              (item) => item.id === statusData.flowId
            );
            if (flow) {
              flow.flowStatusType = statusData.status;
            }
          }
        );
      });
    });
  }
});

onUnmounted(() => {
  if (statusClient.value) {
    statusClient.value.disconnect();
  }
  if (client) {
    client.disconnect();
  }
});

const headerStyle = ref({
  color: "#363636",
  borderBottomColor: "#a9d4fa",
  fontSize: "15px",
  fontWeight: "bolder !important",
  backgroundColor: "#fbfbfb",
});

function convertDate(dateStr) {
  const milliseconds = Date.parse(dateStr);
  const date = new Date(milliseconds);
  return date.toLocaleString();
}

async function getWebhooks() {
  const requestToken = webhooksRequestGuard.start();
  loadingWebhooks.value = true;
  const params = {
    pageNumber: currentPageWebhooks.value - 1,
    pageSize: perPageWebhooks.value,
    sortField: sortField.value,
    ascending: sortAscending.value === "ascending",
    search: search.value,
  };
  try {
    const page = await getWebhookListing(params);
    // OT-4928: discard a stale response superseded by a newer search/request.
    if (!webhooksRequestGuard.isLatest(requestToken)) {
      return;
    }
    webhookList.value = page.data;
    numberOfWebhooks.value = page.totalElements;
  } finally {
    // OT-4928: only the newest request owns the spinner — a superseded one must
    // not clear it, and a newest one that fails must not leave it stuck on.
    if (webhooksRequestGuard.isLatest(requestToken)) {
      loadingWebhooks.value = false;
    }
  }
}

async function startSelectedPayload(webhookPayloadId, flow) {
  if (hasPermission("WEBHOOK.LIST.RUN")) {
    const payload = await getWebhookById(webhookPayloadId);
    payload.loading = true;
    flowName.value = "";
    simulateDialogVisible.value = false;
    flowName.value = flow.name;
    outputBuffer.value = [];
    outputMap.value.clear();
    selectedFlowId.value = flow.id;
    startPayload(webhookPayloadId)
      .then(() => {
        simulateDialogVisible.value = true;
        readFlowProcess(flow, true);
      })
      .catch(() => {
        showAlert(TYPE.ERROR, "An error occurred while starting the payload.");
      })
      .finally(() => {
        payload.loading = false;
      });
  }
}

function logRow(row) {
  outputBuffer.value.push(row);
}

async function readFlowProcess(flow, init) {
  if (outputMap.value.has(flow.id)) {
    outputBuffer.value = outputMap.value.get(flow.id);
  } else if (!init) {
    const latest = await getLatestLogs(flow.id);
    if (latest) {
      outputBuffer.value.splice(0);
      const logRowArray = latest.processLog.log.split("\n");
      logRowArray.forEach(logRow);
    } else {
      outputBuffer.value = [];
    }
  } else {
    outputBuffer.value = [];
  }

  outputMap.value.set(flow.id, outputBuffer.value);
  if (client) {
    client.disconnect();
    client = undefined;
  }

  connectWebsocket().then((stompClient) => {
    stompClient.debug = (f) => f;
    client = stompClient;
    stompClient.connect({}, () => {
      stompClient.subscribe(`/flow/${flow.id}/process`, (val) => {
        outputBuffer.value.push(val.body);
      });
    });
  });
}

watchEffect(() => {
  selectedBuffer.value = outputMap.value.get(selectedFlowId.value);
});

function navigateToActivityPage(row) {
  const activityID = row.activityId;
  router.push(`/activities/${activityID}`);
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(ElCard), {
        id: "webhooks-card",
        class: "card border-0",
        style: {"box-shadow":"unset !important"},
        "body-style": {
        height: '100%',
        padding: '0 8px 8px 8px',
        background: '#fbfbfb',
      }
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ElTable), {
            data: webhookList.value,
            "header-cell-style": headerStyle.value,
            "row-style": 
          _unref(hasPermission)('WEBHOOK.LIST.VIEW')
            ? rowStyle.value
            : { backgroundColor: '#fbfbfb' }
        ,
            "empty-text": loadingWebhooks.value ? ' ' : 'No Data',
            onSortChange: sortChanged,
            "default-sort": { prop: sortField.value, order: sortAscending.value },
            height: "97%",
            onRowClick: navigateToActivityPage
          }, {
            default: _withCtx(() => [
              _createTextVNode(" style=\"background-color: #fbfbfb !important;\" > "),
              _createVNode(_unref(ElTableColumn), {
                label: _unref(t)('Flow.FlowName'),
                prop: "name",
                sortable: "custom",
                width: "auto"
              }, {
                default: _withCtx((scope) => [
                  _createElementVNode("strong", {
                    id: 'name-label-' + scope.$index
                  }, _toDisplayString(scope.row.flow?.name), 9, _hoisted_2)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_unref(ElTableColumn), {
                label: "Status",
                prop: "webhookPayloadStatus",
                sortable: "custom",
                width: "auto"
              }, {
                default: _withCtx((scope) => [
                  (scope.row.webhookPayloadStatus === 'PROCESSED')
                    ? (_openBlock(), _createBlock(_unref(ElTag), {
                        key: 0,
                        type: "info"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scope.row.webhookPayloadStatus), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : (scope.row.webhookPayloadStatus === 'UNPROCESSED')
                      ? (_openBlock(), _createBlock(_unref(ElTag), {
                          key: 1,
                          type: "warning"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(scope.row.webhookPayloadStatus), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : (scope.row.webhookPayloadStatus === 'FAILED')
                        ? (_openBlock(), _createBlock(_unref(ElTag), {
                            key: 2,
                            type: "danger"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(scope.row.webhookPayloadStatus), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : (_openBlock(), _createBlock(_unref(ElTag), { key: 3 }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(scope.row.webhookPayloadStatus), 1)
                            ]),
                            _: 2
                          }, 1024))
                ]),
                _: 1
              }),
              _createVNode(_unref(ElTableColumn), {
                label: "Activity Status",
                prop: "activityStatus",
                sortable: "custom",
                width: "auto"
              }, {
                default: _withCtx((scope) => [
                  (scope.row?.activityStatus === 'TRIGGERED')
                    ? (_openBlock(), _createBlock(_unref(ElTag), {
                        key: 0,
                        type: "info"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(scope.row?.activityStatus), 1)
                        ]),
                        _: 2
                      }, 1024))
                    : (scope.row?.activityStatus === 'STARTING')
                      ? (_openBlock(), _createBlock(_unref(ElTag), {
                          key: 1,
                          type: "warning"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(scope.row?.activityStatus), 1)
                          ]),
                          _: 2
                        }, 1024))
                      : (
                scope.row?.activityStatus === 'FAILED' ||
                scope.row.activityStatus === 'ABORTED'
              )
                        ? (_openBlock(), _createBlock(_unref(ElTag), {
                            key: 2,
                            type: "danger"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(scope.row?.activityStatus), 1)
                            ]),
                            _: 2
                          }, 1024))
                        : (scope.row?.activityStatus === 'COMPLETED')
                          ? (_openBlock(), _createBlock(_unref(ElTag), {
                              key: 3,
                              type: "success"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(scope.row?.activityStatus), 1)
                              ]),
                              _: 2
                            }, 1024))
                          : (
                scope.row?.activityStatus === 'NO_STATUS' ||
                !scope.row.activityStatus
              )
                            ? (_openBlock(), _createBlock(_unref(ElTag), {
                                key: 4,
                                type: "info"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString("NO STATUS"))
                                ]),
                                _: 1
                              }))
                            : (_openBlock(), _createBlock(_unref(ElTag), { key: 5 }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(scope.row?.activityStatus), 1)
                                ]),
                                _: 2
                              }, 1024))
                ]),
                _: 1
              }),
              _createVNode(_unref(ElTableColumn), {
                label: _unref(t)('Common.CreationTime'),
                prop: "createdAt",
                sortable: "custom",
                width: "auto"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(convertDate(scope.row.createdAt)), 1)
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_unref(ElTableColumn), { width: "300px" }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(ElInput), {
                      modelValue: search.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
                      size: "mini",
                      id: "search-input",
                      style: {"max-width":"170px"},
                      onInput: _unref(onSearchInput),
                      placeholder: _unref(t)('Common.TypeToSearch')
                    }, null, 8, ["modelValue", "onInput", "placeholder"]),
                    _createElementVNode("div", _hoisted_4, [
                      _createVNode(_unref(ElButton), {
                        loading: loadingWebhooks.value,
                        id: "refresh-button",
                        class: "no-border btn-oneTeg margin-left-3",
                        size: "mini",
                        onClick: _withModifiers(getWebhooks, ["stop"]),
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_font_awesome_icon, { icon: "redo-alt" })
                        ]),
                        _: 1
                      }, 8, ["loading"])
                    ])
                  ])
                ]),
                default: _withCtx((scope) => [
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(_unref(ElDropdown), null, {
                      dropdown: _withCtx(() => [
                        _createVNode(_unref(ElDropdownMenu), null, {
                          default: _withCtx(() => [
                            (_unref(hasPermission)('WEBHOOK.VIEW_DETAIL'))
                              ? (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                                  key: 0,
                                  id: 'view-button-' + scope.$index,
                                  onClick: _withModifiers(($event: any) => (togglePopup(scope.row.id)), ["stop"])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)("Webhook.Payload")), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["id", "onClick"]))
                              : _createCommentVNode("", true),
                            (_unref(hasPermission)('WEBHOOK.LIST.RUN'))
                              ? (_openBlock(), _createBlock(_unref(ElDropdownItem), {
                                  key: 1,
                                  id: 'run-button-' + scope.$index,
                                  disabled: _unref(isProcessed)(scope.row.webhookPayloadStatus),
                                  onClick: _withModifiers(($event: any) => (
                        startSelectedPayload(scope.row.id, scope.row.flow)
                      ), ["stop"])
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_unref(t)("Webhook.Run")), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["id", "disabled", "onClick"]))
                              : _createCommentVNode("", true)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_unref(ElButton), {
                          class: "no-border btn-oneTeg show-on-row-hover",
                          size: "mini",
                          id: 'gear-' + scope.$index,
                          type: "primary",
                          onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_font_awesome_icon, { icon: "cog" })
                          ]),
                          _: 2
                        }, 1032, ["id"])
                      ]),
                      _: 2
                    }, 1024),
                    (scope.row.loading)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createElementVNode("img", {
                            src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
                            alt: "Loading...",
                            class: "loader-logo-25"
                          }, null, 8, _hoisted_7)
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["data", "header-cell-style", "row-style", "empty-text", "default-sort"]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(OneTegPagination, {
              "page-sizes": [10, 25, 50, 100],
              "page-size": perPageWebhooks.value,
              "onUpdate:pageSize": _cache[2] || (_cache[2] = ($event: any) => ((perPageWebhooks).value = $event)),
              total: numberOfWebhooks.value,
              "current-page": currentPageWebhooks.value,
              "onUpdate:currentPage": _cache[3] || (_cache[3] = ($event: any) => ((currentPageWebhooks).value = $event)),
              background: true,
              small: true,
              onSizeChange: sizeChanged,
              onCurrentChange: getWebhooks,
              layout: 'total, sizes, prev, pager, next'
            }, null, 8, ["page-size", "total", "current-page"])
          ])
        ]),
        _: 1
      }),
      _withDirectives(_createElementVNode("div", _hoisted_9, [
        _createElementVNode("img", {
          src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
          alt: "Loading...",
          class: "loader-logo-40"
        }, null, 8, _hoisted_10)
      ], 512), [
        [_vShow, loadingWebhooks.value]
      ])
    ]),
    (buttonTrigger.value)
      ? (_openBlock(), _createBlock(_unref(ViewPayload), {
          key: 0,
          moved: false,
          stoppable: false,
          payloadContent: payloadContent.value,
          onClosePopup: closePopup
        }, null, 8, ["payloadContent"]))
      : _createCommentVNode("", true),
    (simulateDialogVisible.value)
      ? (_openBlock(), _createBlock(_unref(SimulateDialog), {
          key: 1,
          dialog: simulateDialogVisible.value,
          selectedBuffer: selectedBuffer.value,
          flowName: flowName.value,
          moved: false,
          stoppable: false,
          onClose: closeSimulateDialog
        }, null, 8, ["dialog", "selectedBuffer", "flowName"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})